<div class="spacing-bottom"
    fxLayout.gt-sm="row"
    fxLayout.lt-md="column">
    <div ngClass.gt-sm="spacing-right"
        ngClass.lt-md="spacing-bottom"
        fxFlex.gt-sm="60"
        fxFlex.lt-md="100"
        fxLayout="column">
        <mat-card fxFlex>
            <mat-card-title>
                BACnet
            </mat-card-title>
            <mat-card-content>
                <form [formGroup]="formGroup">
                    <div fxLayout="row" style="margin-bottom: 5px;">
                        <mat-checkbox id="site-deviceName-input"                     
                            formControlName="enabled"
                            (change)="updateModelValuesFormGroup()">
                            Enabled
                        </mat-checkbox>
                    </div>
                    <div fxLayout="row" *ngIf="isNullOrUndefined(bacnet) ? false : bacnet.enabled">
                        <mat-form-field fxFlex="50">
                            <input id="bacnet-deviceid-input"
                                type="number"                                
                                matInput
                                formControlName="deviceId"
                                placeholder="Device ID">
                            <span matSuffix>{{ bacnet?.propertyHasChangesText('deviceId') }}</span>
                            <mat-error>{{getFormControlErrorMessage(formGroup.controls['deviceId'])}}</mat-error>                            
                        </mat-form-field>
                    </div>
                    <div fxLayout="row" *ngIf="isNullOrUndefined(bacnet) ? false : bacnet.enabled">
                        <mat-form-field fxFlex="50"
                            class="spacing-right">
                            <input id="bacnet-port-input"
                                type="number"                                
                                matInput
                                formControlName="port"
                                placeholder="Port">
                            <span matSuffix>{{ bacnet?.propertyHasChangesText('port') }}</span>
                            <mat-error>{{getFormControlErrorMessage(formGroup.controls['port'])}}</mat-error>                            
                        </mat-form-field>                        
                    </div>
                </form>
            </mat-card-content>
        </mat-card>
    </div>
    <div fxFlex.gt-sm="40"
        fxFlex.lt-md="100"
        fxLayout="column">
        <mat-card class="shr-card-sub help-card"
            fxFlex>
            <mat-card-title>
                BACnet
            </mat-card-title>
            <mat-card-content>
                <span>Device ID, is the BACnet device identifier, a unique number assigned to each device on a BACnet network </span>
                <br>
                <br>
                <span class="new-block">Port, The UDP port BACnet traffic should be sent over</span>
            </mat-card-content>
        </mat-card>
    </div>
</div>